import React from 'react'
import { getActivities } from './../utils/api'
import { useState } from 'react'
import { useEffect } from 'react'
import Pagination from 'react-js-pagination'

function UserActivity() {
  const [activities, setActivities] = useState([])
  const [queryData, setQueryData] = useState({ currentPage: 1, totalPages: 1, search: '', status: '', fridate: '' })

  useEffect(() => {
    getActivityData()
  }, [queryData.currentPage])

  function pageChanged(page) {
    let temp = { ...queryData }
    let getUsersFlag = false
    if (temp.currentPage === 1 && page === 1) {
      getUsersFlag = true
    }
    temp.currentPage = page
    setQueryData(temp)
    if (getUsersFlag) {
      getActivityData()
    }
  }

  async function getActivityData() {
    try {
      let response = await getActivities(queryData)
      if (response) {
        let temp = []
        temp = response.data.activities
        temp.forEach((item) => {
          if (!item.from) {
            item.from = { firstName: 'User Deleted' }
          }
          if (!item.to) {
            item.to = { firstName: 'User Deleted' }
          }
        })
        setActivities(temp)
        let tempData = { ...queryData }
        tempData.totalPages = response.data.totalPages
        setQueryData(tempData)
      }
    } catch (err) {
      console.log(err)
    }
  }

  function inputValueChanged(event) {
    let temp = { ...queryData }
    temp[event.target.name] = event.target.value
    setQueryData(temp)
  }

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label htmlFor="inputEmail4">Name/Email/Phone</label>
                  <input type="text" className="form-control" value={queryData.search} name="search" onChange={inputValueChanged} />
                </div>

                <div className="form-group col-md-4">
                  <label htmlFor="inputState">Fridate</label>
                  <select id="inputState" className="form-control" value={queryData.fridate} name="fridate" onChange={inputValueChanged}>
                    <option value='' selected>
                      No
                    </option>
                    <option value='yes'>Yes</option>
                  </select>
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="inputState">Status</label>
                  <select id="inputState" className="form-control" value={queryData.status} name="status" onChange={inputValueChanged}>
                    <option value="" selected>
                      All
                    </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                    <option value="super_like">Super Like</option>
                  </select>
                </div>
              </div>
              <button
                type="button"
                onClick={(e) => {
                  pageChanged(1)
                }}
                className="btn btn-primary"
              >
                Apply
              </button>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-plain table-plain-bg">
              <div className="card-header">
                <h4 className="card-title">Activities List - {queryData.totalPages}</h4>
                <p className="card-category">Activities done on your app by the users</p>
              </div>
              <div className="card-header"></div>
              <div className="card-body table-full-width table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Fridate</th>
                      <th>Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activities.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {item.from && (
                          <td
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              let url = window.location.href
                              let OpenUrl = url.replace('/activities', `/profile?user=${item.from._id}`)
                              window.open(OpenUrl)
                            }}
                          >
                            {item.from.firstName}
                          </td>
                        )}
                        <td
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            let url = window.location.href
                            let OpenUrl = url.replace('/activities', `/profile?user=${item.to._id}`)
                            window.open(OpenUrl)
                          }}
                        >
                          {item.to.firstName}
                        </td>
                        <td>{item.fridate.toString()}</td>
                        <td>{item.activity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Pagination
              activePage={queryData.currentPage}
              itemsCountPerPage={10}
              totalItemsCount={queryData.totalPages}
              pageRangeDisplayed={5}
              itemClass="page-item"
              linkClass="page-link"
              onChange={pageChanged}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export { UserActivity }
